import script from "./list.vue?vue&type=script&lang=ts&setup=true"
export * from "./list.vue?vue&type=script&lang=ts&setup=true"

import "./list.vue?vue&type=style&index=0&id=48744a3a&lang=scss"
import "./list.vue?vue&type=style&index=1&id=48744a3a&lang=scss&scope=true"

const __exports__ = script;

export default __exports__